export enum RiskLabelEnum {
  Low = 0,
  'Below Median' = 1,
  Median = 2,
  'Above Median' = 3,
  High = 4,
  '' = -1,
}
